import { render } from "./app-footer.vue?vue&type=template&id=e8d89fea&scoped=true"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"

import "./app-footer.vue?vue&type=style&index=0&id=e8d89fea&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d89fea"]])

export default __exports__